import * as React from "react";

type TooltipProps = {
    shouldShow: boolean
    message: string
}

export class Tooltip extends React.Component<TooltipProps, {}> {
    render() {
        return (
            this.props.shouldShow &&
            <div className="rj-league-list__tooltip-message-holder" data-uat="div-league-list-tooltip-message-holder">
                <span className="rj-league-list__tooltip-message-content" data-uat="div-league-list-tooltip-message-content">{this.props.message}</span>
            </div>
        )
    }
}